export default "__VITE_ASSET__91d433e8__"